export const search_by = {
    text: 'Наш пошук дапаможа знайсці хутчэй',
    input_text: 'Увядзіце назву арганізацыі',
    searchbtn: 'Знайсці',
    select_text: 'Усе групы прадукцый'
}